<fhm-page [title]="'fhm.backup.title'" [showDone]="true"
  [showSave]="false"
  (doneClicked)="done()"
  [description]="'fhm.backup.description'">

  <fui-rows>
    @if (backupStatus) {
      <fui-row>
        <fui-two-columns>
          <fui-column>
            <fui-text-control [value]="backupStatus.status"
              [label]="'Status'"
              [disabled]="true">
            </fui-text-control>
          </fui-column>
          <fui-column>
            <fui-text-control [value]="backupStatus.lastBackup"
              [label]="'Date/Time'"
              [disabled]="true">
            </fui-text-control>
          </fui-column>
        </fui-two-columns>
      </fui-row>
    }
    @if (backupStatus) {
      <fui-row>
        <fui-two-columns>
          <fui-column>
            <fui-text-control [value]="backupStatus.backupTime"
              [label]="'Backup Time (ms)'"
              [disabled]="true">
            </fui-text-control>
          </fui-column>
        </fui-two-columns>
      </fui-row>
    }


    <fui-row>
      <fui-two-columns>
        <fui-column>
          <fhm-provision-button [title]="'fhm.backup.button.backupNow'" (clicked)="backup()"></fhm-provision-button>
        </fui-column>
      </fui-two-columns>
    </fui-row>
  </fui-rows>

</fhm-page>
